import { Link } from "react-router-dom";

function TopCpn({data={}}){


    const {title="",author="",releaseDate="",timeRead=""} = data || {}

    return (
        <>
            <div className="SingleBlog_singleBlogDiv__IDe5E">
                <div className="Breadcrumbs_mainDiv__F0gZP">
                                        <div className="Breadcrumbs_staticBreadcrumb__rvpFS">
                                        <Link to="/">Trang chủ</Link> &nbsp;{" "}
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 256 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                                        </svg>{" "}
                                        &nbsp;
                                        </div>
                                        <Link className="Breadcrumbs_staticBreadcrumb__rvpFS" to="/blog/">
                                        Blog&nbsp;{" "}
                                        <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 256 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                                        </svg>{" "}
                                        &nbsp;{" "}
                                        </Link>
                                        {/* <span className="Breadcrumbs_dynamicBreadcrumb__cIPo7 Breadcrumbs_uppercase__lP3RB">
                                        analysis
                                        </span> */}
                </div>
                                    
                <div className="BlogHeader_mainDiv__BMHrM">
                    <div className="BlogHeader_blogHeaderDiv__vIU9Z">
                                        <div className="BlogHeader_titleDiv__GkhCm">
                                            <h1>{title}</h1>
                                        </div>
                                        <div className="BlogHeader_aboutBlogDiv__lUyV5">
                                            <div>
                                            By{" "}
                                            <span className="BlogHeader_authorNameDiv__Xzyam">
                                                <a aria-label="go to the author" href="/author/cryptoking/">
                                                    {author}
                                                </a>
                                            </span>
                                            </div>
                                            <div className="BlogHeader_verticalLine__LVpDX" />
                                            <div>Last updated: {releaseDate}</div>
                                            <div className="BlogHeader_verticalLine__LVpDX" />
                                            <div>{timeRead} Min Read</div>
                                        
                                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default TopCpn;